import BigNumber from "bignumber.js";

export const getSimpleAddress = (address: string, length: number) => {
  return (
    address.slice(0, length + 2) +
    "..." +
    address.slice(address.length - length)
  );
};

export const getContractAddress = (apy: number) => {
  switch (apy) {
    case 50:
      return process.env.REACT_APP_STAKING_50_CONTRACT;
    case 30:
      return process.env.REACT_APP_STAKING_30_CONTRACT;
    case 20:
      return process.env.REACT_APP_STAKING_20_CONTRACT;
  }
};

export const fromDecimalData = (value: string | number) => {
  let ret = BigNumber(value);
  ret = ret.dividedBy(Math.pow(10, 5));
  return ret.toString();
};

export const toDecimalData = (value: string | number) => {
  let ret = BigNumber(value);
  ret = ret.multipliedBy(Math.pow(10, 5));
  return ret.toString();
};

export const validateFields = (
  schema: any,
  formNames: string[],
  values: any[]
) => {
  return new Promise((resolve, reject) => {
    let data: any = {};
    formNames.map((formName, index) => {
      data[formName] = values[index];
    });
    schema
      .validate(data, { abortEarly: false })
      .then(() => {
        resolve(true);
      })
      .catch((error: any) => {
        reject(new Error(error.inner[0].message));
      });
  });
};

export const convertToGmtOffsetTime = (date: Date, offset: number): Date => {
  // Get the local time zone offset in minutes (negative means ahead of GMT)
  const localOffset = date.getTimezoneOffset(); // in minutes, negative means behind UTC

  // Convert offset from minutes to milliseconds
  const localTimeInMillis = date.getTime();
  const offsetInMillis = offset * 60 * 60 * 1000;

  // Calculate the new time with the provided offset
  const newTimeInMillis =
    localTimeInMillis + localOffset * 60 * 1000 + offsetInMillis;

  return new Date(newTimeInMillis);
};

export const convertFromGmtOffsetTime = (date: Date = new Date()): Date => {
  // Get the current timezone offset in minutes (positive for behind UTC, negative for ahead of UTC)
  const currentOffset = date.getTimezoneOffset(); // in minutes

  // Calculate the difference in minutes between the current offset and the target offset
  const offsetDifference = currentOffset;

  // Adjust the current time based on the offset difference
  const newTime = new Date(date.getTime() + offsetDifference * 60000); // 60000 ms = 1 minute

  return newTime;
  // return date;
};

export const getLocalGMTOffsetString = () => {
  const date = new Date();
  const offsetMinutes = date.getTimezoneOffset();

  const sign = offsetMinutes > 0 ? "-" : "+";
  const hours = Math.floor(Math.abs(offsetMinutes) / 60);
  const minutes = Math.abs(offsetMinutes) % 60;

  return `GMT ${sign}${String(hours).padStart(2, "0")}:${String(
    minutes
  ).padStart(2, "0")}`;
};
